import { chargePay } from './commands/chargePay.tsx';
import { closeModal } from './commands/closeModal.tsx';
import { configureApiID } from './commands/configureAppID.tsx';
import { pixPay } from './commands/pixPay.tsx';
import { pixStatic } from './commands/pixStatic.tsx';
import { setCustomer } from './commands/setCustomer.tsx';
import { dataLayerHelper } from './DataLayer.tsx';
import type { IOpenPixApi } from './OpenPixApi.tsx';
import { attachOpenPixApi } from './OpenPixApi.tsx';

declare global {
  interface Window {
    $openPix: unknown[] & IOpenPixApi;
    $openpix: unknown[] & IOpenPixApi;
    $woovi: unknown[] & IOpenPixApi;
  }
}

export const setupDataLayerSetup = (dataLayerName: string) => {
  window[dataLayerName] = window[dataLayerName] || [];

  const openPixDataLayer = dataLayerHelper(window[dataLayerName]);

  attachOpenPixApi(window[dataLayerName]);

  openPixDataLayer.registerProcessor('config', configureApiID);
  openPixDataLayer.registerProcessor('pix', pixPay);
  openPixDataLayer.registerProcessor('charge', chargePay);
  openPixDataLayer.registerProcessor('static', pixStatic);
  openPixDataLayer.registerProcessor('customer', setCustomer);
  openPixDataLayer.registerProcessor('close', closeModal);

  openPixDataLayer.process();
};
